import { DEFAULT_STRICTNESS_MODE, STRICTNESS_MODES } from '../constants/aiAuditorSettings';

/** @typedef {import('../entities/AuditSettings.types').AuditStrictness} AuditStrictness */

export const AUDITOR_TEMPLATE_FLAG = 'enableNoteAuditor';

export const AUDITOR_TEMPLATE_STRICTNESS_FIELD = 'noteAuditorStrictness';

export function isAuditorEnabledForTemplate(sessionNoteTemplate) {
  return sessionNoteTemplate?.[AUDITOR_TEMPLATE_FLAG] === true;
} // isAuditorEnabledForTemplate()

/**
 * The strictness the auditor runs at for notes created from this template.
 *
 * Templates that predate the setting carry nothing, and an unrecognised value could only come from
 * a hand-edited document — both resolve to the default rather than reaching the prompt.
 *
 * @param {Object} sessionNoteTemplate
 * @returns {AuditStrictness}
 */
export function resolveTemplateStrictness(sessionNoteTemplate) {
  const stored = sessionNoteTemplate?.[AUDITOR_TEMPLATE_STRICTNESS_FIELD];

  return STRICTNESS_MODES.some(({ value }) => value === stored) ? stored : DEFAULT_STRICTNESS_MODE;
} // resolveTemplateStrictness()
